import { render, staticRenderFns } from "./OrderDetailItem.vue?vue&type=template&id=dac5cec2&"
import script from "./OrderDetailItem.vue?vue&type=script&lang=js&"
export * from "./OrderDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports